export default __webpack_public_path__ + "static/media/specialist.5e41c258.svg";